<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle></template>
          <template v-slot:headerAction>
            <b-button style="right" variant="success" @click="openModal('CREATE', null)">{{
              $t("public.components.role.RoleProfessional.assign")
            }}
            </b-button>
          </template>
          <template v-slot:body>
            <div class="text-right"></div>
            <div>
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headers" :items="roles" item-key="id">
                <template v-slot:item.actions="{ item }">
                  <div class="div-table-data">
                    <button :id="'btnDesassing' + item.id" class="item" v-on:click="openModal('DELETE', item.id)">
                      <i class="ri-delete-bin-line"></i>
                    </button>
                    <b-popover :target="'btnDesassing' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t("public.components.role.RoleProfessional.unAssign")
                      }}
                      </template>
                    </b-popover>
                  </div>
                </template>
              </v-data-table>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal" cancel-title="Cerrar" centered ok-title="Crear" size="lg" title="Rol" @ok="saveFormStep1">
      <template #modal-title><span v-if="optionModal === 'CREATE'">{{
        $t("public.components.role.RoleProfessional.modal.assignRole")
      }}</span></template>
      <template #modal-ok><span v-if="optionModal === 'CREATE'">{{
        $t("public.components.role.RoleProfessional.modal.assign")
      }}</span></template>

      <b-form-group label-for="name">
        <template slot="label">{{ $t("public.components.role.RoleProfessional.modal.assign") }}:
          *
        </template>
        <b-select id="role" v-model="organizationRole" :options="organizationRolesSelect" v-bind:class="{
          'text-danger': isFormOrganizationRoleErrors,
          'is-invalid': isFormOrganizationRoleErrors,
        }" @blur="checkOrganizationRole(organizationRole)">
        </b-select>

        <ul v-if="isFormOrganizationRoleErrors">
          <li v-for="(error, index) in validatorStep1.getErrors(
            'organizationRole'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";

import validator from "vue-m-validator";

import roleService from "../../services/role";

import professionalService from "../../services/professional";

import utilsService from "../../services/utils";

export default {
  name: "RoleProfessional",
  props: {
    professionalId: {},
  },
  mounted() {
    xray.index();
    this.getAll();
  },
  computed: {
    isFormOrganizationRoleErrors() {
      let errors = this.validatorStep1.getErrors("organizationRole");
      return errors && errors.length > 0;
    },
  },
  methods: {
    notFirst() {
      this.isFirstRun = false;
    },
    checkOrganizationRole(_organizationRole) {
      const ORGANIZATIONROLE = _organizationRole;
      const RULE_1 = {
        expression: !ORGANIZATIONROLE || ORGANIZATIONROLE === "",
        name: "organizationRole",
        msg: this.$i18n.t(
          "public.components.role.RoleProfessional.errors.erOrganizationRole"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    clearForm() {
      this.organizationRolesSelect = [];
    },
    openModal(option, id) {
      this.optionModal = option;

      if (option === "CREATE") {
        this.getAllOrganization();
        this.disabled = false;
        this.clearForm();
        this.validatorStep1.errors = [];
        this.$bvModal.show("modal");
      }

      if (option === "DELETE") {
        this.remove(id);
      }
    },
    create() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.assignRole(
          this.professionalId,
          this.organizationRole
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_ROLES", info: "" });
            self.getAll();
            self.$bvModal.hide("modal");

            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.role.RoleProfessional.notifications.title"
              ),
              text: this.$i18n.t(
                "public.components.role.RoleProfessional.notifications.assignSuccess"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.assignRole",
            module: "component-role-roleProfessional",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: this.professionalId,
              organizationRole: this.organizationRole
            }),
          });
        },
        " "
      );
    },
    remove(id) {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.desassignRole(this.professionalId, id),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_ROLES", info: "" });
            self.getAll();
            self.$bvModal.hide("modal");

            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.role.RoleProfessional.notifications.title"
              ),
              text: this.$i18n.t(
                "public.components.role.RoleProfessional.notifications.unAssignSuccess"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.desassignRole",
            module: "component-role-roleProfessional",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: this.professionalId,
              id: id
            }),
          });
        },
        " "
      );
    },
    getAllOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        roleService.getAllWithoutPagination(),
        (response) => {
          if (response) {
            let combo = [];
            response.data.content.forEach(function (item) {
              let notContains = true;
              self.roles.forEach(function (rol) {
                if (rol.id === item.id) {
                  notContains = false;
                }
              });
              if (notContains) {
                combo.push({
                  value: item.id,
                  text: item.name,
                });
              }
            });
            self.organizationRolesSelect = combo;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "roleService.getAllWithoutPagination",
            module: "component-role-roleProfessional",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null,
          });
        },
        " "
      );
    },
    async getAll() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getAllRoles(this.professionalId),
        (response) => {
          if (response) {
            self.roles = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllRoles",
            module: "component-role-roleProfessional",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: this.professionalId
            }),
          });
        },
        " "
      );
    },
    checkFormStep1() {
      this.checkOrganizationRole(this.organizationRole);
    },
    saveFormStep1(evt) {
      evt.preventDefault();
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        if (this.optionModal === "CREATE") {
          this.create();
        }
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.role.RoleProfessional.notifications.error"
          ),
          text: this.$i18n.t(
            "public.components.role.RoleProfessional.notifications.errorStep1"
          ),
          type: "error",
        });
      }
    },
  },
  data() {
    return {
      //Form
      id: "",
      organizationRole: "",

      optionModal: "",
      disabled: false,
      isFirstRun: true,
      isValidateStep1: false,

      validatorStep1: validator,

      headers: [
        {
          text: this.$i18n.t(
            "public.components.role.RoleProfessional.headers.rol"
          ),
          align: "start",
          value: "name",
        },
        { text: "", value: "actions" },
      ],
      headersPermissions: [
        {
          text: this.$i18n.t(
            "public.components.role.RoleProfessional.headers.name"
          ),
          align: "start",
          value: "name",
        },
        { text: "", value: "individual" },
      ],
      roles: [],
      organizationRolesSelect: [],
    };
  },
};
</script>
